var map = {
	"./AddCart.svg": 3385,
	"./AddNewEntity.svg": 7190,
	"./BackPurple.svg": 8657,
	"./BackWhite.svg": 3918,
	"./Calendar.svg": 3044,
	"./Cancel.svg": 1920,
	"./CancelBasic.svg": 9474,
	"./Clock.svg": 7068,
	"./CloseButton.svg": 954,
	"./DeleteButton.svg": 7747,
	"./Desktop---Header.png": 6680,
	"./EditPencil.svg": 4393,
	"./Email.svg": 6970,
	"./ExpandableArrow.svg": 7749,
	"./FooterLogo.png": 7920,
	"./FooterLogo.svg": 1510,
	"./GreenInfoSmall.svg": 1676,
	"./HeaderLogo.svg": 8268,
	"./ItemMenu.svg": 8330,
	"./MapPin.svg": 3305,
	"./MenuButton.svg": 1147,
	"./MergeButton.svg": 2222,
	"./Mobile.svg": 6100,
	"./NewCust.svg": 93,
	"./NewParty.svg": 8832,
	"./NewSale.svg": 5509,
	"./NoEmail.svg": 7585,
	"./NoMobile.svg": 9329,
	"./Phone.svg": 7582,
	"./PlusGreen.svg": 2123,
	"./PlusOrange.svg": 8176,
	"./PlusPurple.svg": 7252,
	"./PlusWhite.svg": 2049,
	"./RedInfoSmall.svg": 2432,
	"./RemoveCart.svg": 2308,
	"./Save.svg": 669,
	"./SearchButton.svg": 5934,
	"./Team.svg": 5329,
	"./TogglerArrow.svg": 9243,
	"./back_order-01.png": 7394,
	"./back_order-02.png": 3977,
	"./bell.png": 135,
	"./check-mark-dark.svg": 6549,
	"./check-mark-white.svg": 5320,
	"./crown-solid.svg": 7741,
	"./discountCodeSent.svg": 6246,
	"./discountCodeUsed.svg": 9819,
	"./emailIcon.svg": 3737,
	"./facebook-square-brands.svg": 8149,
	"./filter.svg": 1420,
	"./house-solid.svg": 1644,
	"./instagram-brands.svg": 5549,
	"./lock_locked.svg": 8488,
	"./lock_locked_outline.svg": 967,
	"./lock_open.svg": 4610,
	"./logo.png": 3153,
	"./menu/dashboard.svg": 5786,
	"./noimage.png": 4338,
	"./order.svg": 6870,
	"./partyLinkClosed.svg": 2174,
	"./partyLinkParty.svg": 4062,
	"./phoneIcon.svg": 4525,
	"./products_header.png": 538,
	"./reserve_OFF.png": 6172,
	"./reserve_ON.png": 4656,
	"./sms.svg": 9209,
	"./step-back-arrow2.png": 5524,
	"./vertical-3dots.svg": 3144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;